import * as AgGrid from "ag-grid-community";
import * as gridUtils from "grid/utils";
import * as datasource from "grid/datasource";
import { GridController } from "grid/grid_controller";
import { DEFAULT_COL_DEF, ACTIONS_COL_DEF } from "../../grid/columns";

interface Seller {
  id: string;
  name: string;
  remove_url?: string;
  actions?: string;
}

export default class extends GridController<Seller> {
  connect() {
    super.connect();
  }

  override buildGrid() {
    const { i18nJson, paginationPageSize, confirmDelete } = this.gridTarget.dataset;
    const i18n = JSON.parse(i18nJson || "{}");

    const colDefs: AgGrid.ColDef[] = [
      { field: "id", ...DEFAULT_COL_DEF, sortable: false },
      { field: "name", ...DEFAULT_COL_DEF, sortable: false },
      {
        ...ACTIONS_COL_DEF,
        cellClass: "actions-cell",
        onCellClicked: (params) => {
          const target = params.event.target as HTMLElement;
          const btn = target?.tagName?.toLowerCase() === "button" ? target : target?.closest("button");
          const action = btn?.dataset?.action;
          if (action !== "remove") return;

          const msgTemplate = confirmDelete || "Delete seller?";
          const msg = msgTemplate.includes("%{name}")
            ? msgTemplate.replace("%{name}", params.node.data.name || "")
            : msgTemplate;
          if (!confirm(msg)) return;

          fetch(params.node.data.remove_url, {
            method: "DELETE",
            headers: {
              "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
            },
          }).then(() => {
            gridApi.purgeInfiniteCache();
          });
        },
      },
    ];

    const { maxBlocksInCache, onCellFocused, ...defaultOptions } = gridUtils.DEFAULT_GRID_OPTIONS;
    const dataSource = new datasource.Datasource({ callbacks: {}, limit: paginationPageSize });

    const options: AgGrid.GridOptions<Seller> = {
      ...defaultOptions,
      defaultColDef: {
        ...(gridUtils.DEFAULT_GRID_OPTIONS.defaultColDef as AgGrid.ColDef<Seller, any>),
      },
      cacheBlockSize: parseInt(paginationPageSize),
      columnDefs: gridUtils.buildColumnDefs(colDefs, { i18n }),
      pagination: true,
      paginationPageSize: parseInt(paginationPageSize),
      datasource: dataSource,
    };

    const gridApi = AgGrid.createGrid(this.gridTarget, { ...options });
    dataSource.gridApi = gridApi;
    return gridApi;
  }
}
